import { render, staticRenderFns } from "./ColorPickerCell.vue?vue&type=template&id=1f073866&scoped=true&"
import script from "./ColorPickerCell.vue?vue&type=script&lang=js&"
export * from "./ColorPickerCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f073866",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VColorPicker,VEditDialog})
